<template>
  <LoadingContainer v-if="loading">
    <ProgressBarMe />
    <ProgressBarAppointments />
    <ProgressBarMeetings />
  </LoadingContainer>
  <CalendarFrame v-else
    :event="event"
    :items="allAnnotated" 
    :timezone="timezone"
    :me="me"
    :slots="slotsAnnotated"
    :tracks="tracks"
  />
</template>

<script>
import { mapGetters } from "vuex";

// import Loading from '@/components/Loading';
import LoadingContainer from '@/components/loading/LoadingContainer';
import ProgressBarAppointments from '@/components/loading/ProgressBarAppointments';
import ProgressBarMe from '@/components/loading/ProgressBarMe';
import ProgressBarMeetings from '@/components/loading/ProgressBarMeetings';

import { addDateObjects } from '@/utils/Item';
import CalendarFrame from "@/views/calendar/CalendarFrame";

// Load Slots, Tracks, Meetings, Appointments
// Pass them into the CalendarFrame for filtering+sorting

export default {
  name: "CalendarApp",
  components: {
    CalendarFrame,
    // Loading,
    LoadingContainer,
    ProgressBarAppointments,
    ProgressBarMe,
    ProgressBarMeetings,
  },
  data: function () {
    return {
      loading: true,
      isLoggedIn: false,
    };
  },
  methods: {
  },
  computed: {
    all() {
      return this.meetings.concat(this.appointments);
    },
    allAnnotated() {
      return this.all.map(item => addDateObjects(item, this.timezone));
    },
    slotsAnnotated() {
      return this.slots.map(item => addDateObjects(item, this.timezone));
    },
    ...mapGetters({
      event: "currentEvent",
      me: "currentAttendee",
      meetings: "meetings/all",
      appointments: "appointments/all",
      // appointments: "appointments/visible",
      slots: "slots/all",
      tracks: "appointments/tracks",
      timezone: "displayTZ",
    }),
  },
  created() {
    /** On creation (and after bootstrapping), load the schema and add it to the data.
     */
    Promise.all([
      this.$store.dispatch("bootstrapOnCreate"),
    ])
    .then(() => {
      if (this.$store.getters['loggedIn']) {
        this.isLoggedIn = true;
        return Promise.all([
          this.$store.dispatch("meetings/fetchMeetings", this.$store.getters['me/currentAttendee']),
          this.$store.dispatch("appointments/fetchAppointments"),
          this.$store.dispatch("slots/fetchSlots"),
        ]);
      } else {
        // Don't try to get meetings for anonymous users
        return Promise.all([
          this.$store.dispatch("appointments/fetchAppointments"),
          this.$store.dispatch("slots/fetchSlots"),
        ]);
      }
    })
    .then(() => {
      this.loading = false;
    });
  },
};
</script>

<style>
:root {
  --col-meeting-confirmed: #1a73e8; /* #090; */
  --col-meeting-inbound: #c00;
  --col-meeting-outbound: #f90;
  --col-meeting-deleted: #999;

  /* Colourblind-safe 'Light' palette
  https://personal.sron.nl/~pault/#fig:scheme_light
  77AADD Light blue
  99DDFF Light cyan
  44BB99 Mint
  BBCC33 Pear
  AAAA00 Olive
  EEBB88 Light yellow
  EE8866 Orange
  FFAABB Pink
  DDDDDD Pale grey
  */
  --col-track0: #77AADD;
  --col-track1: #99DDFF;
  --col-track2: #44BB99;
  --col-track3: #BBCC33;
  --col-track4: #AAAA00;
  --col-track5: #EEBB88;
  --col-track6: #EE8866;
  --col-track7: #FFAABB;
  --col-track-hidden: #333;

  --col-calendar-bg: #ddd;
  --col-calendar-bg-light: #eee;


  /* INVERSE THEME FOR DAY VIEW WHEN --col-meeting-* AND --col-track* USE AS BACKGROUND COLORS */
  
  /* ICON colour flip with partial transparency */
  --col-icon-inverse: #fff8;

  /* Text colors over bright/pastel backgrounds */
  --col-text-meeting: #fff;
  --col-text-appointment: #333;
}
</style>
